export const findDefaultTerminal = (data, defaultDeparture) => {
  for (const item of data) {
    const defaultTerminal = item.terminals.find((terminal) =>
      defaultDeparture.ids.includes(terminal.id)
    )

    if (defaultTerminal) {
      return item
    }
  }

  return null
}

export const findTerminalById = (terminalsMock, terminalId) => {
  for (const country of terminalsMock) {
    for (const terminal of country.terminals) {
      if (terminal.id === terminalId) {
        return terminal
      }
    }
  }
  return null
}

export const filterAndSortTerminals = (terminals, requiredIds) => {
  if (!requiredIds || !Array.isArray(requiredIds) || !terminals || !Array.isArray(terminals))
    return []
  const filtered = terminals.filter((terminal) => {
    return terminal.terminal_ids.some((id) => requiredIds.includes(id))
  })

  filtered.sort((a, b) => a.country.localeCompare(b.country, "uk"))

  return filtered
}

export const getIncludedTerminals = (terminals, requiredIds) => {
  const requiredSet = new Set(requiredIds)

  const filtered = terminals.filter((terminal) =>
    terminal.terminal_ids.some((id) => requiredSet.has(id))
  )

  const grouped = {}
  const allSelected = []

  filtered.forEach((item) => {
    const country = item.country
    const countryCode = item.country_code
    const innerTerminal = { ...item.terminals[0] }
    innerTerminal.is_selected = false

    if (!grouped[country]) {
      grouped[country] = {
        country,
        country_code: countryCode,
        terminals: [],
        terminal_ids: [],
        is_selected: false,
      }
    }

    grouped[country].terminals.push(innerTerminal)
    grouped[country].terminal_ids.push(innerTerminal.id)

    allSelected.push(innerTerminal)
  })

  for (let i = 0; i < Math.min(3, allSelected.length); i++) {
    allSelected[i].is_selected = true

    const countryObj =
      grouped[filtered.find((item) => item.terminals[0].id === allSelected[i].id).country]
    if (countryObj) {
      countryObj.is_selected = true
    }
  }

  return Object.values(grouped)
}

export const getExcludedTerminals = (terminals, requiredIds, selectedIds = []) => {
  const requiredSet = new Set(requiredIds)

  const filtered = terminals.filter(
    (terminal) => !terminal.terminal_ids.some((id) => requiredSet.has(id))
  )

  if (filtered.length === 0) return []

  const idsToSelect = new Set(selectedIds.slice(0, 3))

  const grouped = {}

  filtered.forEach((item) => {
    const country = item.country
    const countryCode = item.country_code
    const innerTerminal = { ...item.terminals[0] }

    innerTerminal.is_selected = idsToSelect.has(innerTerminal.id)

    if (!grouped[country]) {
      grouped[country] = {
        country,
        country_code: countryCode,
        terminals: [],
        terminal_ids: [],
        is_selected: false,
      }
    }

    grouped[country].terminals.push(innerTerminal)
    grouped[country].terminal_ids.push(innerTerminal.id)

    if (innerTerminal.is_selected) {
      grouped[country].is_selected = true
    }
  })

  return Object.values(grouped)
}

export const getAllTerminalsWithSelection = (terminals, selectedIds = []) => {
  if (!terminals || !Array.isArray(terminals)) return []

  const selectedSet = new Set(selectedIds)

  const grouped = {}

  terminals.forEach((item) => {
    const country = item.country
    const countryCode = item.country_code
    const innerTerminal = { ...item.terminals[0] }

    innerTerminal.is_selected = selectedSet.has(innerTerminal.id)

    if (!grouped[country]) {
      grouped[country] = {
        country,
        country_code: countryCode,
        terminals: [],
        terminal_ids: [],
      }
    }

    grouped[country].terminals.push(innerTerminal)
    grouped[country].terminal_ids.push(innerTerminal.id)
  })
  const result = Object.values(grouped)

  return result
}

export const getCountriesFromTerminals = (data) => {
  if (!Array.isArray(data)) {
    return []
  }

  const map = new Map()

  data.forEach((item) => {
    if (!map.has(item.country_code)) {
      map.set(item.country_code, {
        name: item.country,
        code: item.country_code,
      })
    }
  })

  return Array.from(map.values())
}

export const syncCountrySelection = (countries) => {
  return countries.map((country) => ({
    ...country,
    is_selected: country.terminals.some((terminal) => terminal.is_selected),
  }))
}

export const findTerminalByIdV2 = (terminalId, suggestions) => {
  for (const section of suggestions) {
    const terminal = section.terminals?.find((t) => t.id === terminalId)
    if (terminal) {
      return terminal
    }
  }
  return null
}
